
import { defineComponent, useStore } from '@nuxtjs/composition-api';
import AppHeader from '~/domains/header/components/AppHeader';
import AppFooter from '~/domains/footer/components/AppFooter';

export default defineComponent({
  components: { AppFooter, AppHeader },
  middleware: 'checkDevice',
  head() {
    const baseURL = this.$baseURL;
    const { clarityId } = this.$config;
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true });
    const url =
      this.$route.path !== '/' ? `${baseURL}${this.$route.path}` : baseURL;
    const bodyClasses = ['theme-lrg'];
    if (this.$isGreece) bodyClasses.push('is-greece');

    const getClarityScriptById = (id) => {
      return id
        ? [
            {
              hid: 'clarity',
              type: 'text/javascript',
              innerHTML: `(function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "${id}");`,
              charset: 'utf-8',
            },
          ]
        : [];
    };

    return {
      htmlAttrs: {
        ...i18nHead.htmlAttrs,
      },
      bodyAttrs: {
        class: bodyClasses,
      },
      meta: [
        {
          hid: 'og:url',
          property: 'og:url',
          content: url,
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: `${baseURL}/images/lorgar-og.png`,
        },
        ...i18nHead.meta,
      ],
      script: [...getClarityScriptById(clarityId)],
      __dangerouslyDisableSanitizersByTagID: {
        ...(clarityId && {
          clarity: ['innerHTML'],
        }),
      },
    };
  },
  setup() {
    const store = useStore();
    const menuMain = store.getters['menus/getMenuMain'];
    const menuFooter = store.getters['menus/getMenuFooter'];
    const footerCopyrightLinks = store.getters['menus/getFooterCopyrightLinks'];

    return {
      menuMain,
      menuFooter,
      footerCopyrightLinks,
    };
  },
});
